import * as React from 'react';
import { Row, Col, Table, Button } from 'antd';
import '../../../css/ProfileBulkUpload.scss';
import strings from '../../../eyeguide-localization/profile/strings.profile.bulkupload';

const SAMPLEFILE = require('../../../sample/samplefile.csv');
const CSVIMAGE = require('../../../sample/profile_sample.JPG');
const EXCELIMAGE = require('../../../sample/profile_sample_excel.JPG');

interface IUploadProfileContentOneProps {
    handleNextClick: any;
    handlePrevClick: any;    
}

/**
 * State definition
 */
interface IUploadProfileContentOneState {
    columns: Array<any>;
    columnData: Array<any>;
    pagination: any;
    infoColumns: Array<any>;
    infoData: Array<any>;
    current: number;
}

export default class UploadContentOne 
    extends React.Component<IUploadProfileContentOneProps, IUploadProfileContentOneState> {

    constructor(props: IUploadProfileContentOneProps) {
        super(props); 
        this.state = {
            columns: [],
            columnData: [],
            pagination: {},
            infoColumns: this.getInfoColumns(),
            infoData: this.getInfoData(),
            current: 0
        };
    }

    render() {
        return (
            <div className="ProfileBulkUpload">
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={1} />
                    <Col xs={1} sm={1} md={2} lg={19} xl={19} className="labelFrame">
                        <div className="infoText"> {strings.lsRowHeaderTxt} 
                            <b> {strings.lsRowHeaderColTxt} </b>
                            <br/><br/>
                            <Table
                                className="infoTable"
                                columns={this.state.infoColumns}
                                dataSource={this.state.infoData}
                                bordered={false}
                                pagination={false}
                            />
                            <div> {strings.lsCSVUploadInfoTxt1} </div><br/>
                            <div> <b>*</b>{strings.lsCSVUploadInfoTxt5} </div>
                            <br/>
                            <a href={SAMPLEFILE}> 
                                <Button type="primary" size="small">
                                    {strings.lsDloadSampleTxt}
                                </Button>
                            </a>
                            <div className="divSampleFile">
                                {strings.lsCSVUploadInfoTxt2}
                            </div>
                            <div>
                                {strings.lsCSVUploadInfoTxt3}
                            </div><br/>
                            <div> <img className="infoImg" src={CSVIMAGE}/> </div><br/>
                            <div>{strings.lsCSVUploadInfoTxt4}</div><br/>
                            <div><img className="infoImg" src={EXCELIMAGE}/></div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={10} style={{padding: '10px', width: '48%'}}>
                        <div className="buttonRight"> 
                            <Button 
                                onClick={e => {
                                    history.back();
                                }} 
                                type="danger" 
                                style={{width: '100%'}}
                            > 
                            {'Cancel'} 
                            </Button> 
                        </div>
                    </Col>
                    <Col span={10} style={{padding: '10px'}}>
                        <div className="buttonLeft"> 
                            <Button 
                                onClick={e => {                                    
                                    this.props.handleNextClick(true, 1);                                     
                                }}     
                                type="primary"
                                style={{width: '100%'}} 
                            > 
                            {'Next'} 
                            </Button> 
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    /**
     * Sets and returns the columns for the information table.
     */ 
    private getInfoColumns() {
        let columns = [
            {
              title: strings.lsColumnTxt,
              dataIndex: 'column',
              className: 'infoRows'
            },
            {
              title: strings.lsDescriptionTxt,
              dataIndex: 'description',
              className: 'infoRows'
            },
            {
              title: strings.lsRequiredTxt,
              dataIndex: 'required',
              className: 'infoRows'
            }];
        return columns;
    }

    /**
     * Sets and returns the data for Information table.
     */
    private getInfoData() {
        let columnData: Array<any> = [];
        columnData = [{
            column: strings.lsFirstNameTxt,
            description: strings.lsFirstNameTxt,
            required: <span><b>Yes</b></span>,
        }, {
            column: strings.lsMiddleNameTxt,
            description: strings.lsMiddleNamePlaceholderTxt,
            required: 'No',
        }, {
            column: strings.lsLastNameTxt,
            description: strings.lsLastNameTxt,
            required: <span><b>Yes</b></span>,
        }, {
            column: strings.lsIDTxt,
            description: strings.lsIDDescTxt,
            required: 'No',
        }, {
            column: strings.lsDOBTxt,
            description: (
                <div className="clippedDesc">
                    {strings.lsDOBDescTxt}</div>),
            required: <span><b>Yes</b></span>,
        }, {
            column: strings.lsGenderTxt,
            description: <div className="clippedDesc">{strings.lsGenderDescTxt}</div>,
            required: <span><b>Yes</b></span>,
        }, {
            column: strings.lsEmailTxt,
            description: strings.lsEmailDescTxt,
            required: <span><b>Yes*</b></span>,
        }, {
            column: strings.lsPhoneTxt,
            description: strings.lsPhoneDescTxt,
            required: <span><b>Yes*</b></span>,
        }, {
            column: strings.lsSportTxt,
            description: (
                <div className="clippedDesc">
                    {strings.lsSportDescTxt}</div>),
            required: 'No',
        }, {
            column: strings.lsLevelTxt,
            description: (
                <div className="clippedDesc">
                    {strings.lsLevelDescTxt}</div>),
            required: 'No',
        }];
        console.log('columnData', columnData);
        return columnData;
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/uploadprofilesteps/UploadProfileContentOne.tsx